import React, { useEffect } from "react";
import {
  Avatar,
  Box,
  Button,
  Checkbox,
  Container,
  FormControlLabel,
  Grid,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import logo from "../../assets/logo.jpg";
import { Link, Navigate, useNavigate } from "react-router-dom";
import Copyright from "../../components/copyright";
import authStore from "../../stores/authStore";
import brandStore from "../../stores/brandStore";
import { BRAND_IMAGE_URL } from "../../constant";

const SignIn = () => {
  const isNonMobile = useMediaQuery("(min-width: 600px)");
  const AuthStore = authStore();
  const BrandStore = brandStore();
  const navigate = useNavigate();

  const handleSignIn = async (e) => {
    e.preventDefault();
    await AuthStore.signIn();
    navigate("/dashboard");
  };

  useEffect(() => {
    if (AuthStore.loggedIn === null) {
      AuthStore.checkAuth();
    }
  }, []);

  if (AuthStore.loggedIn === true) {
    return <Navigate to="/dashboard" />;
  }

  return (
    <Grid
      item
      container
      component="main"
      sx={{
        width: "100vw",
        height: "100vh",
        backgroundColor: "#F9F1F0",
        alignItems: "center",
        justifyContent: "center",
        display: "flex",
      }}
    >
      <Container
        component="main"
        maxWidth="sm"
        sx={{ mt: isNonMobile ? 0 : 5, mb: isNonMobile ? 0 : 5 }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            verticalAlign: "center",
            backgroundColor: "#fff",
            borderRadius: "10px",
            p: "20px",
          }}
        >
          <Typography
            variant="h4"
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              fontFamily: "Dancing Script",
            }}
          >
            <Avatar
              sx={{
                m: 1,
                bgcolor: "secondary.main",
                height: "50px",
                width: "50px",
                boxShadow: "0 1px 2px var(--babyBlue)",
              }}
            >
              <Box
                component="img"
                src={
                  BrandStore.brand.brandLogo ? `${BRAND_IMAGE_URL}/${BrandStore.brand.brandLogo}` : logo
                }
                sx={{ objectFit: "cover" }}
                width="100%"
                height="100%"
              />
            </Avatar>{" "}
            {BrandStore.brand.brandName}
          </Typography>

          <Typography
            component="h1"
            variant="h5"
            sx={{ fontFamily: "Ysabeau Office" }}
          >
            Sign In
          </Typography>
          <Box
            component="form"
            onSubmit={handleSignIn}
            noValidate={false}
            sx={{ mt: 1 }}
          >
            <TextField
              margin="normal"
              required
              fullWidth
              name="email"
              label="Email Address"
              autoComplete="email"
              autoFocus
              type="email"
              value={AuthStore.signInForm.email}
              onChange={AuthStore.fillSignInForm}
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              type="password"
              autoComplete="current-password"
              value={AuthStore.signInForm.password}
              onChange={AuthStore.fillSignInForm}
            />
            <FormControlLabel
              control={<Checkbox value="remember" color="primary" />}
              label="Remember Me"
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2, fontFamily: "Ysabeau Office" }}
            >
              Sign In
            </Button>
            <Grid container>
              <Grid item xs>
                <Link>
                  <Typography
                    variant="body2"
                    sx={{ fontFamily: "Ysabeau Office", fontSize: "15px" }}
                  >
                    Forgot Password?
                  </Typography>
                </Link>
              </Grid>
              <Grid item>
                <Link to="/sign-up">
                  <Typography
                    variant="body2"
                    sx={{ fontFamily: "Ysabeau Office", fontSize: "15px" }}
                  >
                    Don't Have an account? Sign Up
                  </Typography>
                </Link>
              </Grid>
            </Grid>
          </Box>
        </Box>
        <Copyright
          sx={{ mt: 5, fontFamily: "Ysabeau Office", fontWeight: 700 }}
        />
      </Container>
    </Grid>
  );
};

export default SignIn;
